$(document).ready(function () {

//var elem   = $('#weblinks');

var bottom = 1000; //$(elem).position().top+$(elem).outerHeight(true)

    $(window).scroll(function () {
        if ($(this).scrollTop() > bottom) {
            $('#scroll-top').fadeIn();
        } else {
            $('#scroll-top').fadeOut();
        }
    });

    $('#scroll-top').click(function () {
        $("html, body").animate({ scrollTop: 0 }, 500);
        return false;
    });

});
